<script>
  export let deskSize;
  export let tabSize;
  export let isReversed = false;

  const isSizeDesk = () => (deskSize ? `is-${deskSize}-desktop` : '');
  const isOffSetDesk = () => (deskSize ? `is-offset-${(12 - deskSize) / 2}-desktop` : '');
  const isSizeTab = () => (tabSize ? `is-${tabSize}-tablet` : '');
  const isOffSetTab = () => (tabSize ? `is-offset-${(12 - tabSize) / 2}-tablet` : '');
</script>

<div class={`column ${isSizeDesk()} ${isOffSetDesk()} ${isSizeTab()} ${isOffSetTab()} with-elevation`}>
  <div class={`columns ${isReversed ? 'reverse-columns' : ''}`}>
    <slot />
  </div>
</div>
